module.exports = __webpack_public_path__ + "static/media/AdsIcon.1e43df48.svg";